import { dataProps } from './properties'

export const setContactTagList = (state, payload) => {
    state.list = payload
}    

export const setContactTagData = (state, payload) => {
    state.props = payload
} 

export const resetContactTagData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/contactTag/mutations.js